import { useRef, useEffect } from 'react'
import anime from 'animejs'
import { Box } from '@chakra-ui/react'

import { ReactComponent as Image } from '@/svg/services/recruitment-rafiki.svg'

interface Props {
  animate?: boolean
}

function RecruitmentImage({ animate = true }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && animate) {
      const containerClassName = containerRef.current.className
        .split(' ')
        .join('.')

      const animInstances: anime.AnimeInstance[] = []
      const animateConfig = {
        easing: 'easeInOutSine',
        direction: 'alternate',
        loop: true,
        duration: 1000,
        endDelay: 350,
      }

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #sheet-text > *`,
          scaleX: ['0', '1'],
          direction: 'normal',
          delay: anime.stagger(1000),
        }),
      )

      return () =>
        animInstances.forEach((instance: anime.AnimeInstance) =>
          instance.pause(),
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [containerRef.current, animate])

  return (
    <Box
      ref={containerRef}
      sx={{
        '& > svg *': {
          transformBox: 'fill-box',
        },
      }}
    >
      <Image />
    </Box>
  )
}
export default RecruitmentImage
